import { Mixin } from 'vue-mixin-decorator'
import I18NMixin from '@/_mixins/i18n'
import { emailRegex } from '@/_type/email'
@Mixin
export default class ValidatorMixin extends I18NMixin {
    userNameRules = [(v: any) => !!v || this.getTranslation('fe_validation.error_required')]

    emailRules = [
        (v: any) =>
            !v ||
            emailRegex.test(v.trim()) ||
            this.getTranslation('fe_validation.error_valid_email'),
    ]

    emailRequiredRules = [
        (v: any) => !!v || this.getTranslation('fe_validation.error_required'),
        (v: any) =>
            emailRegex.test(v.trim()) || this.getTranslation('fe_validation.error_valid_email'),
    ]

    validEmailExistsOnOtherUser(emailExistsOnOtherUser) {
        return emailExistsOnOtherUser
            ? this.getTranslation('fe_validation.error_emailExistsOnOtherUser')
            : true
    }

    validEmailAlreadyInAccount(emailAlreadyInAccount) {
        return emailAlreadyInAccount
            ? this.getTranslation('fe_validation.error_emailAlreadyInAccount')
            : true
    }

    phoneNumberRequired = [
        (v: any) => !!v || this.getTranslation('fe_validation.error_required'),
        (v: any) => v.isValid || this.getTranslation('fe_validation.error_valid_phone'),
    ]

    isMobileExistsOnOtherUser(exist: boolean) {
        return exist ? this.getTranslation('fe_validation.error_mobileExistsOnOtherUser') : true
    }

    passwordRules = [(v: any) => !!v || this.getTranslation('fe_validation.error_required')]

    passwordReRules(pass, repass) {
        return [pass == repass ? true : this.getTranslation('fe_validation.error_match_password')]
    }

    requiredField = [(v: any) => !!v || this.getTranslation('fe_validation.error_required')]

    requiredArray = [
        (v: any) => (!!v && v.length > 0) || this.getTranslation('fe_validation.error_required'),
    ]

    maxLength(max: number) {
        return (v: any) =>
            (v && v.length <= max) || this.getTranslation('fe_validation.error_maxLength', { max })
    }

    validSecretRequired(invalidSecret) {
        return invalidSecret ? this.getTranslation('fe_validation.error_invalidMfaSecret') : true
    }
}
